angular
    .module("showcaseApp")
    .component("addressFilter", {
        templateUrl: "app/components/address-filter/address-filter.html",
        bindings: {
            placeholder: "@",
            inputType: '@?',
            model: "=",
            selectedLocations: "=",
            actionOnClose: '&',
            fullscreen: '='
        },
        controller: "addressFilterController",
    })
    .directive("addressInputChange", function ($timeout, $document) {
        return {
            restrict: "A",
            link: function (scope, elem, attrs) {
                var ctrl = scope.$ctrl;

                function resetSuggestions() {
                    ctrl.suggestions = [];
                    ctrl.cities = [];
                    ctrl.neighborhoods = [];
                    ctrl.streets = [];
                    ctrl.pointOfInterest = [];
                    ctrl.states = [];
                }

                function isDuplicateSuggestion(suggestion, suggestionsList) {
                    if (!suggestionsList || !Array.isArray(suggestionsList)) {
                        return false;
                    }
                    return suggestionsList.some(function(existing) {
                        return existing === suggestion;
                    });
                }

                function displaySuggestions(predictions, status) {
                    if (!predictions || status !== google.maps.places.PlacesServiceStatus.OK || !predictions.length) {
                        scope.$applyAsync(function () {
                            resetSuggestions();
                        });
                        return;
                    }

                    resetSuggestions();

                    predictions.forEach(function (suggestion) {
                        if (isDuplicateSuggestion(suggestion)) {
                            return;
                        }

                        var types = suggestion.types;

                        if (types.includes("route")) {
                            ctrl.streets.push(suggestion);
                        } else if (types.includes("point_of_interest")) {
                            ctrl.pointOfInterest.push(suggestion);
                        } else if (types.includes("sublocality") || suggestion.structured_formatting.secondary_text.split(' ').length > 2) {
                            ctrl.neighborhoods.push(suggestion);
                        } else if (types.includes("locality")) {
                            ctrl.cities.push(suggestion);
                        } else if (types.includes("administrative_area_level_1")) {
                            ctrl.states.push(suggestion)
                        }
                    });

                    scope.$applyAsync();
                }

                var debounceTimeout;
                function fetchSuggestions(query) {
                    if (debounceTimeout) {
                        $timeout.cancel(debounceTimeout);
                    }

                    debounceTimeout = $timeout(function () {
                        if (!query || query.length < 3) {
                            return;
                        }

                        var autocomplete = new google.maps.places.AutocompleteService();
                        autocomplete.getQueryPredictions(
                            {
                                input: query,
                                componentRestrictions: { country: "br" },
                                types: ["(regions)"],
                                language: "pt-BR"
                            },
                            displaySuggestions
                        );
                    }, 300);
                }

                scope.$watch(attrs["ngModel"], function (newValue) {
                    fetchSuggestions(newValue);
                });

            },
        };
    });
